export default __webpack_public_path__ + "static/media/foundations.9e3976dc.jpg";